"use client";

import React, { useEffect, useRef, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const lifestyleImages = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/premium_vineyard_agriculture.png",
  alt: "Lush vineyard representing agriculture sector expertise",
  className: "w-[65vw] md:w-[30vw] aspect-[4/5] object-cover grayscale hover:grayscale-0 transition-all duration-700 border border-primary/10 shadow-xl"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/aerospace_clean_room_facility.png",
  alt: "High-tech aerospace clean room facility",
  className: "w-[80vw] md:w-[40vw] aspect-video object-cover grayscale hover:grayscale-0 transition-all duration-700 border border-primary/10 shadow-xl"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/modern_food_beverage_manufacturing.png",
  alt: "Sleek food and beverage production line",
  className: "w-[55vw] md:w-[25vw] aspect-square object-cover grayscale hover:grayscale-0 transition-all duration-700 border border-primary/10 shadow-xl"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1657590/img/logistics_distribution_hub_sunset.png",
  alt: "Advanced logistics and distribution hub at sunset",
  className: "w-[85vw] md:w-[45vw] aspect-[3/2] object-cover grayscale hover:grayscale-0 transition-all duration-700 border border-primary/10 shadow-xl"
}];
export default function FragmentsOfADay() {
  const sectionRef = useRef<HTMLElement>(null);
  const [translateX, setTranslateX] = useState(0);
  const {
    ref: revealRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const rect = sectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      if (rect.top < windowHeight && rect.bottom > 0) {
        const scrollProgress = (windowHeight - rect.top) / (windowHeight + rect.height);
        setTranslateX(scrollProgress * -15);
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  return <section data-section-id="223420" id="sector-specialization" ref={sectionRef} className="bg-background py-24 md:py-32 overflow-hidden relative">
      <div ref={revealRef as React.RefObject<HTMLDivElement>} className={`transition-opacity duration-1000 ease-out ${isVisible ? "opacity-100" : "opacity-0"}`}>
        <div className="px-6 md:px-12 mb-16 max-w-4xl">
          <h2 className="text-4xl md:text-5xl font-default text-primary mb-6 tracking-tight">
            Sector Specialization
          </h2>
          <p className="text-lg md:text-xl font-serif text-muted-foreground leading-relaxed">
            Deep operational insight across high-barrier industries. We navigate the complexities of Food & Beverage, Aerospace, and Manufacturing to unlock institutional-grade value.
          </p>
        </div>
        
        <div className="flex items-center will-change-transform w-[285vw] md:w-[140vw]" style={{
        transform: `translate3d(${translateX}%, 0, 0)`
      }}>
          {lifestyleImages.map((img, i) => <div key={i} data-index={i} className="shrink-0 px-4 group relative">
              <div className="absolute inset-0 bg-primary/40 group-hover:bg-transparent transition-colors duration-500 z-10 mx-4" />
              <img src={img.src} alt={img.alt} className={img.className} loading={i < 2 ? "eager" : "lazy"} />
            </div>)}
        </div>
      </div>
    </section>;
}